// Filters for the Gantt and the detail table below it: phase, status, owner.
// Owner options are the names actually present in the current item set, not
// the list of who currently holds edit rights; a plan item can be owned by
// someone who has since lost can_edit_dev_plan, and that name has to stay
// filterable.
import { Label } from '../../lib/shadcn/label'
import { NativeSelect } from '../../lib/shadcn/native-select'
import { statusLabel, type DevPlanFilterState } from '../../utils/devPlan'

export function DevPlanFilters({
  value,
  onChange,
  phases,
  statuses,
  owners,
}: {
  value: DevPlanFilterState
  onChange: (next: DevPlanFilterState) => void
  phases: { phase_key: string; label: string }[]
  statuses: string[]
  owners: string[]
}) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <Label className="text-xs">Phase</Label>
        <NativeSelect
          value={value.phaseKey ?? ''}
          onChange={(e) => onChange({ ...value, phaseKey: e.target.value || null })}
        >
          <option value="">All phases</option>
          {phases.map((p) => (
            <option key={p.phase_key} value={p.phase_key}>
              {p.label}
            </option>
          ))}
        </NativeSelect>
      </div>
      <div>
        <Label className="text-xs">Status</Label>
        <NativeSelect
          value={value.status ?? ''}
          onChange={(e) => onChange({ ...value, status: e.target.value || null })}
        >
          <option value="">All statuses</option>
          {statuses.map((s) => (
            <option key={s} value={s}>
              {statusLabel(s)}
            </option>
          ))}
        </NativeSelect>
      </div>
      <div>
        <Label className="text-xs">Owner</Label>
        <NativeSelect
          value={value.owner ?? ''}
          onChange={(e) => onChange({ ...value, owner: e.target.value || null })}
        >
          <option value="">All owners</option>
          {owners.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </NativeSelect>
      </div>
    </div>
  )
}
